/** On `<html>` while a Dealstack AI view transition runs; scopes its pseudo-element timing. */
export const DS_AI_VIEW_TRANSITION_CLASS = 'dealstack-ai-view-transition';

/** Shared by the modal and in-page processing cards, so "Open analysis" morphs one into the other. */
export const PROCESSING_CARD_VIEW_TRANSITION_NAME = 'dealstack-ai-processing-card';
